import React, {useState} from 'react'
import Header from '../Login/Header';
import Close from '../Assets/Close.svg';
import { useNavigate } from 'react-router-dom';
import Back from '../Assets/back-svgrepo-com.svg';
import DocX from '../Assets/DocX.svg';
import SumX from '../Assets/Sum X.svg';
import QNA from '../Assets/Q&A.svg';
import QNAalter from '../Assets/qa.svg';
import MedX from '../Assets/MedX.jpg';
import AIVoiceX from '../Assets/ai-voice-generator.webp';
import Modal from 'react-bootstrap/Modal';

function LandingScreen() {
    const navigate = useNavigate();

    const [lgShow, setLgShow] = useState(false);
    const [ModalName, setModalName] = useState('');
    const [ModalImg, setModalImg] = useState('');

    const handleModal = (name, img) => {
        setModalName(name);
        setModalImg(img);
        setLgShow(true);
    }

  return (
    <div>
      <Header border={false} signOut={true} />
      <hr className='my-0'/>
      {/* <div className={`d-flex flex-wrap justify-content-end align-items-center`} style={{ width: '100%', height: '6vh', background: '#0473ea',position:'relative', zIndex: '10'}}>
        <p className="mb-0 px-4" style={{ color: '#fff', fontSize: '12px', fontWeight: '500', cursor: 'pointer' }} onClick={() => navigate('/')}><img src={Logout} className='me-2' width='25px' />Sign Out</p>
      </div> */}
      <div className="row p-0 m-0 py-4 px-4 Landing_screen_card">
        <p className='text-start all-apps mb-0'>All Apps</p>
        {/* <div className='col-4 docx-card px-3'>
            <div className='card-box'>
            <div style={{width: '35%', height: '100%'}}>
                <img className='card-img' src={DocX} width='100%'></img>
            </div>
            <div className='px-3 d-flex flex-wrap align-items-start' style={{width: '65%', height: '100%'}}>
              <div className='pt-3 text-start'>
                <h5 className='mb-3' style={{fontWeight: '600'}}>DocX</h5>
                <p style={{fontSize: '14px'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been...</p>
                <div className='pb-3'>
                    <button className='px-3 py-2 explore-btn' onClick={()=>navigate('/Home/DocX')}>Explore</button>
                </div>
              </div>
            </div>
            </div>
        </div>
        <div className='col-4 docsum-card px-2'>
            <div className='card-box'>
            <div style={{width: '35%', height: '100%'}}>
                <img className='card-img' src={DocX} width='100%'></img>
            </div>
            <div className='px-3 d-flex flex-wrap align-items-start' style={{width: '65%', height: '100%'}}>
              <div className='pt-3 text-start'>
                <h5 className='mb-3' style={{fontWeight: '600'}}>SumX</h5>
                <p style={{fontSize: '14px'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been...</p>
                <div className='pb-3'>
                    <button className='px-3 py-2 explore-btn' onClick={()=>navigate('/Home/DocSum')}>Explore</button>
                </div>
              </div>
            </div>
            </div>
        </div>
        <div className='col-4 qna-card px-3'>
          <div className='card-box'>
            <div style={{width: '35%', height: '100%'}}>
                <img className='card-img' src={DocX} width='100%'></img>
            </div>
            <div className='px-3 d-flex flex-wrap align-items-start' style={{width: '65%', height: '100%'}}>
              <div className='pt-3 text-start'>
                <h5 className='mb-3' style={{fontWeight: '600'}}>Question & Answer</h5>
                <p style={{fontSize: '14px'}}>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been...</p>
                <div className='pb-3'>
                    <button className='px-3 py-2 explore-btn' onClick={()=>navigate('/Home/Q&A')}>Explore</button>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* New Card */}
        <div className='col-4 card-container px-5 py-4'>
          <div className='card-box' onClick={()=>navigate('/Home/DocX')}>
            <div style={{width: '100%', height: '65%', background: '#AEBAF4', borderTopRightRadius: '5px', borderTopLeftRadius: '5px'}}>
                <img className='card-img' src={DocX} height='100%'></img>
            </div>
            <div className='px-3 d-flex flex-wrap align-items-start' style={{width: '100%', height: '35%'}}>
              <div className='pt-3 text-start'>
                <h5 className='title'>DocX</h5>
                <p className='mb-0 sub-text'>Xtract key info from documents efficiently and accurately</p>
              </div>
            </div>
          </div>
        </div>

        <div className='col-4 card-container px-5 py-4'>
          <div className='card-box' onClick={()=>navigate('/Home/DocSum')}>
            <div className='d-flex align-items-end' style={{width: '100%', height: '65%', background: '#AEBAF4', borderTopRightRadius: '5px', borderTopLeftRadius: '5px'}}>
                <img className='card-img' src={SumX} height='88%'></img>
            </div>
            <div className='px-3 d-flex flex-wrap align-items-start' style={{width: '100%', height: '35%'}}>
              <div className='pt-3 text-start'>
                <h5 className='title'>SumX</h5>
                <p className='mb-0 sub-text'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>
          </div>
        </div>

        <div className='col-4 card-container px-5 py-4'>
          <div className='card-box' onClick={()=>navigate('/Home/Q&A')}>
            <div className='d-flex align-items-end' style={{width: '100%', height: '65%', background: '#AEBAF4', borderTopRightRadius: '5px', borderTopLeftRadius: '5px'}}>
                <img className='card-img' src={QNAalter} height='88%'></img>
            </div>
            <div className='px-3 d-flex flex-wrap align-items-start' style={{width: '100%', height: '35%'}}>
              <div className='pt-3 text-start'>
                <h5 className='title'>Q & A</h5>
                <p className='mb-0 sub-text'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>
          </div>
        </div>

        <div className='col-4 card-container px-5 py-4'>
          <div className='card-box' onClick={()=>navigate('/Home/Q&A')}>
            <div className='d-flex align-items-end' style={{width: '100%', height: '65%', background: '#AEBAF4', borderTopRightRadius: '5px', borderTopLeftRadius: '5px'}}>
                <img className='card-img' src={QNAalter} height='88%'></img>
            </div>
            <div className='px-3 d-flex flex-wrap align-items-start' style={{width: '100%', height: '35%'}}>
              <div className='pt-3 text-start'>
                <h5 className='title'>POS</h5>
                <p className='mb-0 sub-text'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>
          </div>
        </div>

        <div className='col-4 card-container px-5 py-4'>
          <div className='card-box' onClick={() => handleModal('MedX', MedX)}>
            <div style={{width: '100%', height: '65%', background: '#AEBAF4', borderTopRightRadius: '5px', borderTopLeftRadius: '5px', position: 'relative'}}>
                <img className='card-img' src={MedX} height='100%' width='100%' style={{filter: 'blur(4px)'}}></img>
                <div className='comingSoon-div'>Coming Soon</div>
            </div>
            <div className='px-3 d-flex flex-wrap align-items-start' style={{width: '100%', height: '35%'}}>
              <div className='pt-3 text-start'>
                <h5 className='title'>MedX</h5>
                <p className='mb-0 sub-text'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>
          </div>
        </div>

        <div className='col-4 card-container px-5 py-4'>
          <div className='card-box' onClick={() => handleModal('AI VoiceX', AIVoiceX)}>
            <div style={{width: '100%', height: '65%', background: '#AEBAF4', borderTopRightRadius: '5px', borderTopLeftRadius: '5px', position: 'relative'}}>
                <img className='card-img' src={AIVoiceX} height='100%' width='100%' style={{filter: 'blur(4px)'}}></img>
                <div className='comingSoon-div'>Coming Soon</div>
            </div>
            <div className='px-3 d-flex flex-wrap align-items-start' style={{width: '100%', height: '35%'}}>
              <div className='pt-3 text-start'>
                <h5 className='title'>AI VoiceX</h5>
                <p className='mb-0 sub-text'>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <Modal
        size="lg"
        show={lgShow}
        onHide={() => setLgShow(false)}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header>
          {/* <Modal.Title id="example-modal-sizes-title-lg">
            Large Modal
          </Modal.Title> */}
          <div className='modal-img'>
            <img src={ModalImg} height='100%' width='100%' style={{filter: 'blur(4px)'}}></img>
            <div className='modal-close-btn' onClick={() => setLgShow(false)}>
                <img src={Close} />
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
            <div>
                <h4 className='mb-3 modal-title-text'>{ModalName} &nbsp; - &nbsp; Coming Soon</h4>
                <p className='modal-text'>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia, looked up one of the more obscure Latin words, consectetur, from a Lorem Ipsum passage, and going through the cites of the word in classical literature, discovered the undoubtable source. Lorem Ipsum comes from sections 1.10.32 and 1.10.33 of "de Finibus Bonorum et Malorum" (The Extremes of Good and Evil) by Cicero, written in 45 BC. This book is a treatise on the theory of ethics, very popular during the Renaissance. The first line of Lorem Ipsum, "Lorem ipsum dolor sit amet..", comes from a line in section 1.10.32.</p>
            </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default LandingScreen;
